@use '@/scss/underscore' as _;

.headlineWithMultiInputs {
  padding-right: _.unit(9);
}
